import { TypographyColor } from 'components/_common/Typography/Typography';
import theme from 'theme';
import { ThemeUIStyleObject } from 'theme-ui';

export type FlexDirectionProperty = 'column' | 'row' | 'row-reverse' | 'column-reverse';

export const focusStyles = (config?: {
  tight?: boolean;
  invert?: boolean;
}): ThemeUIStyleObject => ({
  outline: sxtheme(t => `2px solid ${config?.invert ? t.colors.white : t.colors.deepSea60}`),
  outlineOffset: config?.tight ? 0 : '2px',
});

export function sxtheme<T>(funct: (t: typeof theme) => T) {
  return funct;
}

// HACK: e52ccb17: aligning prob icon plane "ground" with img and propcard buttons
export const valignHackTop = (top: string | string[]): ThemeUIStyleObject => {
  return {
    position: 'relative',
    top: top,
  };
};
export const valignHackBottom = (bottom: string | string[]): ThemeUIStyleObject => {
  return {
    position: 'relative',
    bottom: bottom,
  };
};

// TODO: d5f7224a: rework active states using sxMixinActiveHover
export const sxMixinActiveHover = (): ThemeUIStyleObject => {
  return {
    cursor: 'pointer',
    '&:hover': {
      bg: sxtheme(t => t.colors.deepSea20),
      transition: '0.5s all',
    },
    // LESSON: ":active MUST come after :hover (if present) in the CSS definition in order to be effective!" (LINK: https://www.w3schools.com/cssref/sel_active.asp)
    '&:active': {
      bg: sxtheme(t => t.colors.deepSea30),
    },
    '&.active': {
      bg: sxtheme(t => t.colors.seafoam20),
    },
  };
};

export const sxSemanticHackResponsiveVerticalMenu = (): ThemeUIStyleObject => {
  return {
    '&.ui.vertical.menu': {
      // textAlign: ['center', null],
      width: ['100%', null],
      mx: [0, null],
    },
  };
};

export const gridColGap: string = '24px';
export const gridStandardColumns = [
  'repeat(3, 1fr) 1fr [last-col]',
  'repeat(7, 1fr) 1fr [last-col]',
  'repeat(11, 1fr) 1fr [last-col]',
];
export const gridStandardColumnsSpanFull = ['1 / span 5', '1 / span 9', '1 / span 12'];

/**
 * Returns the appropriate container grid style depending on the width of the container
 *
 * NOTE: THIS SHOULD BE WRAPPED IN A CONTAINER WITH "display: 'flex'" and "justifyContent: 'center'" TO
 *       GET THE CENTER ALIGNMENT IN BIG SCREENS WHERE THE MARGIN MAY BE BIGGER THAN 32PX
 *
 * When making a component match to a column you must specify which gridColumn it starts on
 * EG: gridColumn: '2' starts on the second column
 *     gridColumn: '3 / span 4' starts on the 3rd column and spans 4
 *
 */
export const gridStyleNoPadding: ThemeUIStyleObject = {
  display: 'grid',
  gridTemplateColumns: gridStandardColumns,
  columnGap: gridColGap,
  width: '100%',
};

export const mainContentStyles: ThemeUIStyleObject = {
  width: '100%',
  maxWidth: '1200px',
  mx: '32px',
  px: '0',
  '@media screen and (max-width: 1263px)': {
    mx: 0,
    px: ['16px', '16px', '32px'],
  },
};

export const gridStyle: ThemeUIStyleObject = {
  ...gridStyleNoPadding,
  ...mainContentStyles,
};

export const headerBoxShadow = '0px 3px 3px rgb(60 63 77 / 7%), 0px 3px 4px rgb(60 63 77 / 8%)';

/**
 * Maps a colour that would be on a light screen, then turns it into it's dark theme equivalent
 * @param inColor colour to map to a colour on dark
 */
export const mapColorToDark = (inColor: TypographyColor | string) => {
  switch (inColor) {
    case theme.colors.deepSea70:
    case 'deepSea70':
      return 'deepSea50';
    default:
      return inColor;
  }
};

export const skeletonItemColor: ThemeUIStyleObject = { bg: t => t.colors.deepSea20 };

export const resetButtonStyles: ThemeUIStyleObject = {
  background: 'none',
  color: 'inherit',
  border: 'none',
  padding: '0',
  font: 'inherit',
  cursor: 'pointer',
  outline: 'inherit',
  textAlign: 'inherit',
};
